import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { IWidgetAdpOrder } from "@modules/limit-orders/interfaces/limit-orders-widget-adp.model";
import { OrderType } from "@gql/offer";

export interface OpenDetailsModel {
	orderId: string;
	orderType: OrderType;
}

@Component({
	selector: "order-adp-widget",
	templateUrl: "./order-adp-widget.component.html",
	styleUrls: ["./order-adp-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class OrderAdpWidgetComponent {
	public readonly orderType = OrderType;
	public readonly assetMetal = "metal";

	@Input() public order: IWidgetAdpOrder;
	@Output() public onOpenDetails = new EventEmitter<OpenDetailsModel>();

	public openDetails(orderId: string, orderType: OrderType): void {
		this.onOpenDetails.emit({ orderId, orderType });
	}
}
